import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";

export function ConfidenceBar({
  value,
  tone = "neutral",
  className,
}: {
  value: number | null | undefined;
  tone?: "antisemitic" | "not_antisemitic" | "neutral";
  className?: string;
}) {
  if (value == null) {
    return (
      <span className="text-xs text-muted-foreground">No classification</span>
    );
  }
  const pct = Math.round(value * 100);
  const indicator =
    tone === "antisemitic"
      ? "bg-destructive"
      : tone === "not_antisemitic"
        ? "bg-[color:var(--color-success)]"
        : "bg-primary";
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Progress
        value={pct}
        className="h-1.5 w-24 bg-secondary/60"
        indicatorClassName={indicator}
      />
      <span className="w-10 text-right text-[11px] tabular-nums text-muted-foreground">
        {pct}%
      </span>
    </div>
  );
}
